import React from "react";
import { MdOutlineSentimentVeryDissatisfied } from "react-icons/md";
import IconNota from "../IconNota";
import Typography from "../../Typography";
import ProgressBar from "../../ProgressBar";

export default function ProgressBarNota({ nota = 0 }) {
    return (
        <div className="w-full h-25px justify-start items-center gap-3 inline-flex">
            <IconNota nota={nota} />
            <div className="grow shrink basis-0 h-25px justify-start items-center gap-3 flex">
                {nota || nota == 0 ? <>
                    <ProgressBar nota={nota} />
                    <div className="w-[38px] flex-col justify-start items-end gap-2.5 inline-flex">
                        <div className="text-slate-800 text-sm font-bold font-['Roboto'] leading-normal">{(nota * 10).toFixed(0)}/10</div>
                    </div>
                </> : <Typography component="tbody2">Sem resultados até o momento.</Typography>}
            </div>
        </div>

    )
}